if (typeof customElements.get('mega-menu-metaobject') === 'undefined') {
  class MegaMenuMetaobject extends HTMLElement {
    connectedCallback() {
      this.#sidebarLinks = this.querySelectorAll('[data-mega-menu-tab]');
      this.#panels = this.querySelectorAll('[data-mega-menu-panel]');

      if (!this.#sidebarLinks.length || !this.#panels.length) {
        return;
      }

      this.addEventListener('pointerover', (event) => {
        const tab = event.target.closest('[data-mega-menu-tab]');

        if (!tab || !this.contains(tab)) {
          return;
        }

        this.#activate(tab.dataset.megaMenuTab);
      });

      this.addEventListener('focusin', (event) => {
        const tab = event.target.closest('[data-mega-menu-tab]');

        if (!tab || !this.contains(tab)) {
          return;
        }

        this.#activate(tab.dataset.megaMenuTab);
      });
    }

    #activate(panelIndex) {
      if (panelIndex == null || panelIndex === '') {
        return;
      }

      const activeIndex = String(panelIndex);

      for (const link of this.#sidebarLinks) {
        const isActive = link.dataset.megaMenuTab === activeIndex;
        const sidebarItem = link.closest('.mega-menu-metaobject__sidebar-item');

        link.classList.toggle('is-active', isActive);
        sidebarItem?.classList.toggle('is-active', isActive);
        link.setAttribute('aria-selected', isActive ? 'true' : 'false');
        link.setAttribute('tabindex', isActive ? '0' : '-1');
      }

      for (const panel of this.#panels) {
        const isActive = panel.dataset.megaMenuPanel === activeIndex;

        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
    }

    #sidebarLinks = [];
    #panels = [];
  }

  customElements.define('mega-menu-metaobject', MegaMenuMetaobject);
}
